import { Dispatch, SetStateAction } from 'react';
import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
  useMemo,
} from 'react';
import { useTranslation } from 'react-i18next';
import * as cts from '../../../constants/ui/svg';
import { Switch, Input, Spin, Empty, Tooltip } from 'antd';
import { IMAGE_BASE_URL } from '../../../constants';
import SortableItem from './SortableItem';
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';
import { getToken } from 'helpers';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import ModalSelectItemProgram from './ModalSelectItemProgram';
import { rankingAction } from 'slices/rankingSlice';
import { successToast } from 'helpers';
import ModalDeleteImage from '../../settings/components/ModalDeleteImage';
import { LoadingOutlined } from '@ant-design/icons';
import ModalChangeLayoutRankingItem from './ModalChangeLayoutRankingItem';
import { generateImage } from 'helpers/functionHelper';
import ShopNoLogo from '../../../assets/images/no-logo.png';
import { Shop } from 'models';
import { shopListAction } from 'slices/shopSlice';
import customHistory from 'utils/customHistory';
import moment from 'moment';
import { useDimension } from 'hooks/useDimension';

type OrderByRankingItem = {
  id: number;
  layout_ranking: number;
  name: string;
  shop_id: number;
  status: number;
  value: number;
  created_at: string;
  updated_at: string;
};

type SelectedItem = {
  created_at: string;
  description: string | null;
  id: number;
  link: string;
  order_by: number;
  shop_id: number;
  title: string | null;
  type: number;
  updated_at: string;
};
type SliderItem = {
  order_by_image_slider_ranking_id: number;
  order_by_images_slider_ranking: SliderItem;
  created_at: string;
  id: number;
  images_slider: null | SelectedItem;
  images_slider_id: null | number;
  order_by: number;
  order_by_ranking: OrderByRankingItem;
  order_by_ranking_id: number;
  program_rank_id: number;
  layout_ranking: null | number;
  second_change: number | string;
  shop_id: number;
  type: number;
  updated_at: string;
  select_shop_id: number;
  select_shop: Shop;
  master_id: number;
  link: string;
  isNewMedia: boolean;
  isNewRankingOfShopMaster: boolean;
  layout_quantity_user_slider_ranking: number;
  quantity_user_slider_app_rank: number;
  is_group_ranking: boolean;
  name: string;
  // Note data for Beside layout (0)
  note_beside?: string | null;
  font_beside?: string | null;
  font_size_beside?: number | null;
  color_beside?: string | null;
  stroke_color_beside?: string | null;
  stroke_width_beside?: number | null;
  // Note data for Slider layout (1)
  note_slider?: string | null;
  font_slider?: string | null;
  font_size_slider?: number | null;
  color_slider?: string | null;
  stroke_color_slider?: string | null;
  stroke_width_slider?: number | null;
  permissions_staff_creator: any;
  ranking_list_shop: Array<any>;
  delete_ranking_list_shop_ids?: Array<number>;
  // note_app_ranking: Array<NoteAppRankingTypes>;
};
type rankArr = {
  note?: string;
  rank?: number;
  disable_nomination_day?: number;
  disable_nomination_month?: number;
  disable_profit_day?: number;
  disable_profit_month?: number;
  time_nomination_day?: number;
  time_nomination_month?: number;
  time_profit_day?: number;
  time_profit_month?: number;
};
type Props = {
  setSelectedProgram: Dispatch<SetStateAction<{}>>;
};

type RankingName = 'PROFIT_DAY' | 'PROFIT_MONTH' | 'NOMINATION_DAY' | 'NOMINATION_MONTH';

const ProgramingV2 = forwardRef(({ setSelectedProgram }: Props, ref) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const token = getToken() as string;
  const { width } = useDimension();
  const isMobile = width < 768;
  const rankArr: Array<{ rank: number }> = [
    { rank: 1 },
    { rank: 2 },
    { rank: 3 },
    { rank: 4 },
    { rank: 5 },
    { rank: 6 },
    { rank: 7 },
    { rank: 8 },
    { rank: 9 },
    { rank: 10 },
  ];
  const keysByRankingName = {
    PROFIT_DAY: 'disable_profit_day',
    PROFIT_MONTH: 'disable_profit_month',
    NOMINATION_DAY: 'disable_nomination_day',
    NOMINATION_MONTH: 'disable_nomination_month',
  };

  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const imageSlider = useAppSelector((state) => state.ranking.imageSlide);
  const orderByImagesSliderRank = useAppSelector((state) => state.ranking.orderByImagesSliderRank);
  const orderByImagesSliderRankLoading = useAppSelector(
    (state) => state.ranking.orderByImagesSliderRankLoading
  );
  const noteAppRanking = useAppSelector((state) => state.ranking.noteAppRanking);
  // if current account is not master, this state will return empty object
  const masterInfo = useAppSelector((state) => state.auth.masterInfo);
  const orderByRankingInPosRanking = useAppSelector(
    (state) => state.ranking.orderByRankingInPosRanking
  );

  const listShop = useAppSelector((state) => state.shopList.listShop);
  const programRank = useAppSelector((state) => state.ranking.programRank);
  const listPermissionByUser = useAppSelector((state) => state.shopSetting.permissionByUser);

  const dropdownRefs = useRef<any[]>([]);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const [arrOption, setArrOption] = useState<any>({});
  const [openSelectLayout, setOpenSelectLayout] = useState<boolean>(false);
  const [selectSection, setSelectSection] = useState<any>();
  const [openModalDeleteImage, setOpenModalDeleteImage] = useState(false);
  const [selectItem, setSelectItem] = useState<any>({});
  const [openModalSelectItem, setOpenModalSelectItem] = useState(false);
  const [imageSliderState, setImageSliderState] = useState<SliderItem[]>([]);
  const [isMore, setIsMore] = useState<any>([]);
  const [noteWithOptionRank, setNoteWithOptionRank] = useState<any>([]);
  const [typeDelete, setTypeDelete] = useState('');
  const [selectedItemRanking, setSelectedItemRanking] = useState<any>({});
  const [showScrollTop, setShowScrollTop] = useState<boolean>(false);
  const [hasScroll, setHasScroll] = useState<boolean>(false);

  const isMaster = masterInfo.active && !selectShop.id;

  //------------ON SAVE---------------
  const newArray: any = useMemo(() => {
    return imageSliderState.map((item) => {
      const { permissions_staff_creator, images_slider, id, ...cleanItem } = item;
      const matchedItem = orderByImagesSliderRank.find((x: any) => {
        if (cleanItem.is_group_ranking && cleanItem.ranking_list_shop?.length > 0)
          return x.id === id;
        if (cleanItem.order_by_ranking_id) {
          return (
            x.order_by_ranking_id === cleanItem.order_by_ranking_id &&
            x.select_shop_id === cleanItem.select_shop_id
          );
        }
        if (cleanItem.images_slider_id) {
          return x.images_slider_id === cleanItem.images_slider_id;
        }
        if (cleanItem.order_by_image_slider_ranking_id) {
          return x.order_by_image_slider_ranking_id == cleanItem.order_by_image_slider_ranking_id;
        }
      });
      // for debug, do not delete
      const layoutRanking = cleanItem?.link ? 0 : (cleanItem?.layout_ranking ?? 0);
      const baseData = {
        ...cleanItem,

        ...(matchedItem?.id && !item.isNewMedia && !item.isNewRankingOfShopMaster
          ? {
              id: matchedItem?.id,
            }
          : {}),

        ...(cleanItem.order_by_ranking_id
          ? { order_by_ranking_id: cleanItem.order_by_ranking_id }
          : cleanItem.images_slider_id
            ? { images_slider_id: cleanItem.images_slider_id }
            : {}),

        program_rank_id: selectItem?.id,
        layout_ranking: layoutRanking,

        type: cleanItem.order_by_image_slider_ranking_id
          ? cleanItem.order_by_images_slider_ranking?.type || 1
          : cleanItem?.type || 1,

        ...(cleanItem.order_by_image_slider_ranking_id
          ? (() => {
              const {
                id,
                order_by,
                layout_ranking,
                type,
                program_rank_id,
                images_slider,
                permissions_staff_creator,
                ...rest
              } = cleanItem.order_by_images_slider_ranking || {};
              return {
                type_update: 2,
                ...rest,
              };
            })()
          : {}),
      };

      // Chỉ gửi note theo layout
      if (layoutRanking === 0) {
        return {
          ...baseData,
          note_beside: cleanItem.note_beside || null,
          font_beside: cleanItem.font_beside || null,
          font_size_beside: cleanItem.font_size_beside || null,
          color_beside: cleanItem.color_beside || null,
          stroke_color_beside: cleanItem.stroke_color_beside || null,
          stroke_width_beside: cleanItem.stroke_width_beside || null,
        };
      }

      return {
        ...baseData,
        note_slider: cleanItem.note_slider || null,
        font_slider: cleanItem.font_slider || null,
        font_size_slider: cleanItem.font_size_slider || null,
        color_slider: cleanItem.color_slider || null,
        stroke_color_slider: cleanItem.stroke_color_slider || null,
        stroke_width_slider: cleanItem.stroke_width_slider || null,
      };
    });
  }, [imageSliderState, orderByImagesSliderRank, selectItem?.id]);

  const getShopMaster = imageSliderState
    .flatMap(
      (item) =>
        item.shop_id ||
        item.select_shop_id ||
        item.ranking_list_shop.map((rankingShopItem) => rankingShopItem.select_shop_id)
    )
    .filter(Boolean);
  const uniqueShop = Array.from(new Set(getShopMaster));
  // list shop has permission by master
  const listShopHasPermission = listPermissionByUser
    .filter((item) => item.name == 'enable_ranking_program_master')
    .map((item) => item.shop_id);

  const onDelete = () => {
    setTypeDelete('main');
    setOpenModalDeleteImage(true);
  };

  // console.log('imageSliderState: ', imageSliderState);

  const onSave = () => {
    const sortedArr2 = [...orderByImagesSliderRank].sort((a, b) => a.order_by - b.order_by);
    const isEqualArray = (arr1: any[], arr2: any[]) => {
      if (arr1.length !== arr2.length) return false;

      return arr1.every((obj1, idx) => {
        const obj2 = arr2[idx];
        return (
          obj1.id === obj2.id &&
          obj1.order_by === obj2.order_by &&
          obj1.layout_ranking === obj2.layout_ranking &&
          obj1.second_change === obj2.second_change
        );
      });
    };

    if (!isEqualArray(newArray, sortedArr2)) {
      if (isMaster) {
        dispatch(
          rankingAction.updateOrderByImagesSliderRanking({
            token,
            data: {
              shop_ids: listShopHasPermission,
              input: newArray,
            },
          })
        );
      } else {
        dispatch(
          rankingAction.updateOrderByImagesSliderRanking({
            token,
            data: { shop_id: selectShop?.id, input: newArray },
          })
        );
      }
    }
    // update layout screen of program
    if (isMaster) {
      dispatch(
        rankingAction.updateProgramRank({
          token,
          id: Number(selectItem?.id),
          data: {
            shop_id: 0,
            layout_screen: selectItem?.layout_screen || 1,
          },
        })
      );
    } else {
      dispatch(
        rankingAction.updateProgramRank({
          token,
          id: Number(selectItem?.id),
          data: {
            shop_id: selectShop.id,
            layout_screen: selectItem?.layout_screen || 1,
          },
        })
      );
    }

    // Update note_with_option_rank (chỉ cho các field disable/time, KHÔNG phải note text/font/color)
    // Note: note text/font/color đã được lưu qua updateOrderByImagesSliderRankingApi trong newArray
    if (noteWithOptionRank?.filter((i: any) => i?.is_edit).length > 0) {
      const arrEditOptionRank = noteWithOptionRank
        ?.filter((i: any) => i?.is_edit)
        ?.map((i: any) => {
          if (i?.order_by_image_slider_ranking_id === null) {
            const found = imageSliderState?.find((item: any) => item.id === i?.order_by_ranking_id);

            return {
              ...i,
              order_by_image_slider_ranking: {
                order_by: found?.order_by,
                type: 1,
                order_by_ranking_id: i?.order_by_ranking_id,
                second_change: found?.second_change,
              },
            };
          }
          return i;
        });
      if (isMaster) {
        if (!uniqueShop.includes(selectShop.id!)) {
          dispatch(
            rankingAction.updateNoteWithOptionRank({
              token,
              data: {
                shop_id: null,
                note_app_rankings: arrEditOptionRank,
              },
            })
          );
        } else {
          dispatch(
            rankingAction.updateNoteWithOptionRank({
              token,
              data: {
                shop_ids: listShopHasPermission,
                note_app_rankings: arrEditOptionRank,
              },
            })
          );
        }
      } else {
        dispatch(
          rankingAction.updateNoteWithOptionRank({
            token,
            data: {
              shop_id: selectShop?.id,
              note_app_rankings: arrEditOptionRank,
            },
          })
        );
      }
    }

    if (
      !isEqualArray(newArray, sortedArr2) ||
      noteWithOptionRank?.filter((i: any) => i?.is_edit).length > 0
    ) {
      setTimeout(() => {
        successToast('更新成功');
      }, 1000);
    }
  };

  // const onEditNote = (e: any, item: any, section: any) => {
  //   const value = e.target.value;

  //   if (!/^\d*$/.test(value)) return;

  //   const numValue = Number(value);

  //   if (numValue > Number(section?.second_change || 0)) return;

  //   const idx = noteWithOptionRank.findIndex(
  //     (i: any) =>
  //       i?.rank === item?.rank &&
  //       (i?.order_by_image_slider_ranking_id === section?.id ||
  //         i?.order_by_ranking_id === section?.order_by_ranking_id)
  //   );

  //   if (idx === -1) return;

  //   const rankingName = orderByRankingInPosRanking?.find(
  //     (x: any) => x.id === section?.order_by_ranking_id
  //   )?.name;

  //   const key =
  //     rankingName === 'PROFIT_DAY'
  //       ? 'time_profit_day'
  //       : rankingName === 'PROFIT_MONTH'
  //         ? 'time_profit_month'
  //         : rankingName === 'NOMINATION_DAY'
  //           ? 'time_nomination_day'
  //           : 'time_nomination_month';

  //   const updated = [...noteWithOptionRank];

  //   updated[idx] = {
  //     ...updated[idx],
  //     [key]: numValue,
  //     delete: numValue ? 0 : 1,
  //     is_edit: 1,
  //   };
  //   setNoteWithOptionRank(updated);
  // };

  const onEditNote = (e: any, item: any, section: any) => {
    const value = e.target.value;

    if (value === '') {
      // const idx = noteWithOptionRank.findIndex(
      //   (i: any) =>
      //     i?.rank === item?.rank &&
      //     (i?.order_by_image_slider_ranking_id === section?.id ||
      //       i?.order_by_ranking_id === section?.order_by_ranking_id)
      // );
      const idx = noteWithOptionRank.findIndex((i: any) => {
        if (i?.rank !== item?.rank) return false;
        const isGroupRankingItem = item.ranking_list_shop.length !== 0;
        if (isGroupRankingItem) {
          return i?.order_by_image_slider_ranking_id === section?.id && isGroupRankingItem;
        }

        return (
          i?.order_by_image_slider_ranking_id === section?.id ||
          i?.order_by_ranking_id === section?.order_by_ranking_id
        );
      });
      if (idx === -1) return;

      const rankingName = orderByRankingInPosRanking?.find(
        (x: any) => x.id === section?.order_by_ranking_id
      )?.name;

      const key = keysByRankingName[rankingName as RankingName];

      const updated = [...noteWithOptionRank];

      updated[idx] = {
        ...updated[idx],
        [key]: '',
        delete: 1,
        is_edit: 1,
      };

      setNoteWithOptionRank(updated);
      return;
    }

    if (!/^\d*$/.test(value)) return;

    const numValue = Number(value);

    if (numValue > Number(section?.second_change || 0)) return;

    // const idx = noteWithOptionRank.findIndex(
    //   (i: any) =>
    //     i?.rank === item?.rank &&
    //     (i?.order_by_image_slider_ranking_id === section?.id ||
    //       i?.order_by_ranking_id === section?.order_by_ranking_id)
    // );
    const idx = noteWithOptionRank.findIndex((i: any) => {
      if (i?.rank !== item?.rank) return false;
      const isGroupRankingItem = item.ranking_list_shop.length !== 0;
      if (isGroupRankingItem) {
        return i?.order_by_image_slider_ranking_id === section?.id && isGroupRankingItem;
      }

      return (
        i?.order_by_image_slider_ranking_id === section?.id ||
        i?.order_by_ranking_id === section?.order_by_ranking_id
      );
    });
    if (idx === -1) return;

    const rankingName = orderByRankingInPosRanking?.find(
      (x: any) => x.id === section?.order_by_ranking_id
    )?.name;
    const key = keysByRankingName[rankingName as RankingName];

    const updated = [...noteWithOptionRank];

    updated[idx] = {
      ...updated[idx],
      [key]: numValue,
      delete: numValue ? 0 : 1,
      is_edit: 1,
    };

    setNoteWithOptionRank(updated);
  };

  const toggleOpen = useCallback(
    (item: any, checked: boolean, section: any): void => {
      const isGroupRankingSection = section.ranking_list_shop?.length > 0;
      const idx = noteWithOptionRank.findIndex((i: any) => {
        if (i?.rank !== item?.rank) return false;

        const isGroupRankingItem = item.ranking_list_shop?.length > 0;
        if (isGroupRankingItem) {
          return (
            i?.order_by_image_slider_ranking_id === section?.id &&
            isGroupRankingItem &&
            i?.order_by === section?.order_by
          );
        }

        const isAnotherShopRankingItem = section?.select_shop_id;
        if (isAnotherShopRankingItem) {
          return (
            i?.order_by_ranking_id === section?.order_by_ranking_id &&
            i?.order_by === section?.order_by
          );
        }
        return (
          i?.order_by_image_slider_ranking_id === section?.id ||
          i?.order_by_ranking_id === section?.order_by_ranking_id
        );
      });
      // if (isGroupRankingSection) {
      //   const indexGroupRankingSection = imageSliderState.findIndex(
      //     (x: any) => x.id === section?.id
      //   );
      //   if (indexGroupRankingSection !== -1) {
      //     const rankingName = section?.order_by_ranking?.name;
      //     const key = keysByRankingName[rankingName as RankingName];
      //     const noteAppRanking = imageSliderState[idx].note_app_ranking || [];
      //     imageSliderState[idx] = {
      //       ...imageSliderState[idx],
      //       note_app_ranking: noteAppRanking.map((noteItem: any) => {
      //         // if (noteItem.id === section.id) {
      //         return {
      //           ...noteItem,
      //           [key]: checked ? 0 : 1,
      //         };
      //         // }
      //         // return noteItem;
      //       }),
      //     };

      //     setImageSliderState([...imageSliderState]);
      //   }
      // } else {
      //   if (idx !== -1) {
      //     const rankingName = orderByRankingInPosRanking?.find(
      //       (item: any) => item.id === section?.order_by_ranking_id
      //     )?.name;
      //     const key = keysByRankingName[rankingName as RankingName];

      //     const updated = [...noteWithOptionRank];

      //     updated[idx] = {
      //       ...updated[idx],
      //       [key]: checked ? 0 : 1,
      //       is_edit: 1,
      //     };
      //     setNoteWithOptionRank([...updated]);
      //   }
      // }
      if (idx !== -1) {
        const rankingName = orderByRankingInPosRanking?.find(
          (item: any) => item.id === section?.order_by_ranking_id
        )?.name;
        const key = keysByRankingName[rankingName as RankingName];

        const updated = [...noteWithOptionRank];

        updated[idx] = {
          ...updated[idx],
          [key]: checked ? 0 : 1,
          is_edit: 1,
        };
        setNoteWithOptionRank([...updated]);
      }
    },
    [noteWithOptionRank, orderByRankingInPosRanking, keysByRankingName]
  );

  //-----------ORDER_BY_SORT
  const sensors = useSensors(useSensor(PointerSensor));

  const handleMainDragEnd = useCallback(
    (event: any) => {
      const { active, over } = event;
      if (!over || active.id === over.id) return;

      const oldIndex = imageSliderState.findIndex(
        (item: any, index) => `${item.id}-${item.order_by}-${index}` === active.id
      );
      const newIndex = imageSliderState.findIndex(
        (item: any, index) => `${item.id}-${item.order_by}-${index}` === over.id
      );

      if (oldIndex === -1 || newIndex === -1) return;

      const newList = arrayMove(imageSliderState, oldIndex, newIndex);
      const updatedList = newList.map((item: any, index) => ({
        ...item,
        order_by: index + 1,
      }));

      setImageSliderState(updatedList);
    },
    [imageSliderState, setImageSliderState]
  );
  const shopInfoRanking = (shopItem: SliderItem) => {
    const shopFound = listShop.find((item) =>
      shopItem?.select_shop_id || shopItem?.order_by_images_slider_ranking?.select_shop_id
        ? item.id ===
          (shopItem.select_shop_id ?? shopItem.order_by_images_slider_ranking?.select_shop_id)
        : item.id === shopItem?.shop_id
    );

    return shopFound;
  };
  const groupShopInfoRanking = (shopItem: SliderItem) => {
    const listGroupRankingShops = isMaster
      ? shopItem.ranking_list_shop
      : shopItem.order_by_images_slider_ranking.ranking_list_shop;
    const shopInfoInGroupShop = listShop.filter((shop) =>
      listGroupRankingShops
        ?.map((rankingGroupShop) => rankingGroupShop.select_shop_id)
        ?.includes(shop.id)
    );

    return shopInfoInGroupShop;
  };

  const __renderShopRankingImage = (shopItem: SliderItem) => {
    const shopFound = listShop.find((item) =>
      shopItem?.select_shop_id || shopItem?.order_by_images_slider_ranking?.select_shop_id
        ? item.id ===
          (shopItem.select_shop_id ?? shopItem.order_by_images_slider_ranking?.select_shop_id)
        : item.id === shopItem?.shop_id
    );

    if (!shopFound) return <></>;
    return (
      <img
        src={
          shopFound.avatar_image && (shopFound?.avatar_image ?? '')
            ? generateImage(shopFound?.avatar_image)
            : ShopNoLogo
        }
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = ShopNoLogo;
        }}
        alt=""
        // className="rounded-lg min-w-[50px] h-8 border border-solid border-border-gray object-cover"
        className="rounded-lg min-w-[70px] h-[45px] border border-solid border-border-gray object-cover"
      />
    );
  };

  const __renderGroupShopTooltipName = (shopItem: SliderItem) => {
    if (!groupShopInfoRanking(shopItem)) return <></>;
    const shopNames =
      groupShopInfoRanking(shopItem)
        ?.map((shop) => shop.name)
        .sort((a, b) => a.localeCompare(b, 'ja'))
        .join(', ') ?? '';
    return (
      <Tooltip title={isMobile ? '' : shopNames} placement="top">
        <p className="truncate cursor-pointer max-w-60">{shopNames}</p>
      </Tooltip>
    );
  };

  const __renderGroupShopRankingImage = (shopItem: SliderItem) => {
    const isRankingGroupShopRankingItem = shopItem.is_group_ranking;
    if (!isRankingGroupShopRankingItem) return <></>;
    return (
      <div className="rounded-lg min-w-[70px] h-[45px] flex items-center justify-center bg-[#9A9A9A]">
        {cts.groupShopRankingIcon}
      </div>
    );
  };

  const __renderRankingLayoutType = (type: number) => {
    return type === 1 ? '（個人） ' : '（一覧）';
  };

  const sortableItems = imageSliderState.map(
    (item: any, index: number) => `${item.id}-${item.order_by}-${index}`
  );

  const __renderDisplayPositionRanking = (section: any, noteItem: any) => {
    const checkedByRankingType = (note: any) => {
      switch (section.order_by_ranking.name) {
        case 'PROFIT_DAY':
          return note?.disable_profit_day !== 1;
        case 'PROFIT_MONTH':
          return note?.disable_profit_month !== 1;
        case 'NOMINATION_DAY':
          return note?.disable_nomination_day !== 1;
        case 'NOMINATION_MONTH':
          return note?.disable_nomination_month !== 1;
        default:
          return false;
      }
    };
    return (
      <Switch
        className="switch_rank"
        // defaultChecked
        // checked={
        //   section.ranking_list_shop?.length > 0
        //     ? section.note_app_ranking.some((note: any) =>
        //         section.order_by_ranking.name === 'PROFIT_DAY'
        //           ? note?.disable_profit_day !== 1
        //           : section.order_by_ranking.name === 'PROFIT_MONTH'
        //             ? note?.disable_profit_month !== 1
        //             : section.order_by_ranking.name === 'NOMINATION_DAY'
        //               ? note?.disable_nomination_day !== 1
        //               : note?.disable_nomination_month !== 1
        //       )
        //     : section.order_by_ranking.name === 'PROFIT_DAY'
        //       ? noteItem?.disable_profit_day !== 1
        //       : section.order_by_ranking.name === 'PROFIT_MONTH'
        //         ? noteItem?.disable_profit_month !== 1
        //         : section.order_by_ranking.name === 'NOMINATION_DAY'
        //           ? noteItem?.disable_nomination_day !== 1
        //           : noteItem?.disable_nomination_month !== 1
        // }
        checked={
          // section.ranking_list_shop?.length > 0
          //   ? section.note_app_ranking?.some((note: any) => checkedByRankingType(note))
          //   : checkedByRankingType(noteItem)
          checkedByRankingType(noteItem)
        }
        onChange={(checked) => toggleOpen(noteItem, checked, section)}
      />
    );
  };

  const handleMoveToTop = () => {
    scrollRef.current?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleDeleteImage = useCallback(() => {
    if (typeDelete === 'program') {
      const matchedItem = orderByImagesSliderRank.find((x: any) => x.id === selectSection?.id);
      // check trường hợp nếu login bằng acc master thì gửi shop id = 0,
      // còn không phải acc master thì xét trường hợp nếu item ranking đó là của master tạo thì thêm type_delete = 2, còn không thì không cần gửi
      if (matchedItem?.id) {
        if (isMaster) {
          dispatch(
            rankingAction.deleteOrderByImagesSliderRanking({
              token,
              data: { shop_id: 0 },
              id: selectSection.id,
            })
          );
        } else {
          // check nếu item ranking đó là của master tạo thì thêm type delete = 2
          if (
            selectSection.order_by_image_slider_ranking_id &&
            selectSection.order_by_image_slider_ranking_id !== null
          ) {
            dispatch(
              rankingAction.deleteOrderByImagesSliderRanking({
                token,
                data: { shop_id: selectShop?.id, type_delete: 2 },
                id: selectSection?.id,
              })
            );
            // xóa item ranking bình thường
          } else {
            dispatch(
              rankingAction.deleteOrderByImagesSliderRanking({
                token,
                data: { shop_id: selectShop?.id },
                id: selectSection?.id,
              })
            );
          }
        }
        setOpenModalDeleteImage(false);
      } else {
        setImageSliderState((prev) =>
          prev.filter(
            (item) => !(item.id === selectSection?.id && item.order_by === selectSection?.order_by)
          )
        );

        setOpenModalDeleteImage(false);
      }
    } else if (typeDelete === 'main' && selectItem?.id) {
      dispatch(
        rankingAction.deleteProgramRank({
          token,
          id: Number(selectItem?.id),
          data: { shop_id: selectShop?.id },
        })
      );
      setOpenModalDeleteImage(false);
    }
  }, [typeDelete, selectItem, selectSection]);

  useImperativeHandle(ref, () => ({
    onSave,
    onDelete,
  }));

  const getListNoteAppRanking = useCallback(() => {
    if (isMaster) {
      if (!uniqueShop.length) return;

      uniqueShop.forEach((shopId) => {
        dispatch(rankingAction.getNoteAppRanking({ token, params: { shop_id: String(shopId) } }));
      });
    } else {
      if (selectShop?.id) {
        dispatch(
          rankingAction.getNoteAppRanking({ token, params: { shop_id: String(selectShop?.id) } })
        );
      }
    }
  }, [dispatch, token, selectShop?.id, uniqueShop.length]);

  useEffect(() => {
    getListNoteAppRanking();
  }, [getListNoteAppRanking]);

  useEffect(() => {
    if (!newArray?.length) return;
    const newState: Array<any> = newArray
      .filter((x: any) => x?.order_by_ranking_id)
      .flatMap((it: any) => {
        const ranks =
          // it?.select_shop_id && it?.quantity_user_slider_app_rank && isMaster
          it?.quantity_user_slider_app_rank
            ? Array.from({ length: it.quantity_user_slider_app_rank }, (_, i) => ({ rank: i + 1 }))
            : rankArr;
        return ranks.map(({ rank }: rankArr) => {
          const matchedNote = noteAppRanking.find((note: any) => {
            return (
              note?.rank === rank &&
              (note?.order_by_images_slider_ranking?.order_by_ranking_id ===
                it.order_by_ranking_id ||
                note?.order_by_image_slider_ranking_id === it.id)
            );
          });

          return {
            ...it,
            id: matchedNote?.id || null,
            rank,
            disable_nomination_day: matchedNote?.disable_nomination_day || null,
            disable_nomination_month: matchedNote?.disable_nomination_month || null,
            disable_profit_day: matchedNote?.disable_profit_day || null,
            disable_profit_month: matchedNote?.disable_profit_month || null,
            time_nomination_day: matchedNote?.time_nomination_day || null,
            time_nomination_month: matchedNote?.time_nomination_month || null,
            time_profit_day: matchedNote?.time_profit_day || null,
            time_profit_month: matchedNote?.time_profit_month || null,
            order_by_image_slider_ranking_id: it.id,
            type: 1,
            order_by_ranking_id: it.order_by_ranking_id,
            order_by_image_slider_ranking: {
              order_by: it?.order_by,
              type: 1,
              order_by_ranking_id: it?.order_by_ranking_id,
              second_change: it?.second_change,
            },
            program_rank_id: selectItem?.id,
          };
        });
      });

    setNoteWithOptionRank(newState);
    // console.log('newState: ', newState);
    // setImageSliderState((prev) => {
    //   return prev.map((item) => {
    //     const matchedImage = newState.find((stateItem: any) => {
    //       return item.order_by_ranking_id === stateItem.order_by_ranking_id;
    //     });
    //     if (matchedImage?.id) {
    //       item.note_app_ranking = newState.filter(
    //         (stateItem: any) => stateItem.order_by_ranking_id === matchedImage.order_by_ranking_id
    //       );
    //     }
    //     return item;
    //   });
    // });
  }, [noteAppRanking.length, newArray, isMaster]);
  // console.log('image slider state: ', imageSliderState);
  // console.log('ismore: ', isMore);
  // console.log('note: ', noteWithOptionRank);
  useEffect(() => {
    setSelectItem(programRank);
    setSelectedProgram(programRank);
    setArrOption(programRank);
  }, [programRank]);

  useEffect(() => {
    if (selectShop.id) {
      const params = {
        shop_id: selectShop?.id,
        type: 1,
      };
      dispatch(rankingAction.getImageSlider({ token, params }));
    } else {
      const params = {
        permission: 'master',
        type: 1,
      };
      dispatch(rankingAction.getImageSlider({ token, params }));
    }
  }, [selectShop.id]);

  useEffect(() => {
    if (token && selectShop?.id) {
      dispatch(
        rankingAction.fetchOrderByRankingInPosRanking({
          token,
          params: { shop_id: selectShop.id },
        })
      );
    } else {
      dispatch(
        rankingAction.fetchOrderByRankingInPosRanking({
          token,
          params: { permission: 'master' },
        })
      );
    }
  }, [dispatch, selectShop?.id, token]);

  useEffect(() => {
    if (!token) return;
    if (selectShop?.id) {
      dispatch(
        rankingAction.getProgramRank({
          token,
          params: { shop_id: selectShop.id },
        })
      );
    } else {
      dispatch(
        rankingAction.getProgramRank({
          token,
          params: { permission: 'master' },
        })
      );
    }
  }, [dispatch, selectShop?.id, token]);

  useEffect(() => {
    if (orderByImagesSliderRank && orderByImagesSliderRank.length > 0) {
      // Default values cho note style
      const defaultNoteStyle = {
        font: 'NotoSansNormal',
        font_size: 20,
        color: '#FEC84B',
        stroke_color: '#ffffff',
        stroke_width: 2,
      };

      const sortedData = [...orderByImagesSliderRank]
        .sort((a: any, b: any) => {
          const aItem = a.order_by == null;
          const bItem = b.order_by == null;

          if (aItem && !bItem) return -1;
          if (!aItem && bItem) return 1;

          if (aItem && bItem) {
            return (
              (a.order_by_images_slider_ranking?.order_by ?? 0) -
              (b.order_by_images_slider_ranking?.order_by ?? 0)
            );
          }

          return (a.order_by ?? 0) - (b.order_by ?? 0);
        })
        .map((item: any) => {
          // Lấy name từ order_by_ranking nếu note null (dịch sang tiếng Nhật )
          const defaultNote = item.order_by_ranking?.name ? t(item.order_by_ranking.name) : null;

          return {
            ...item,
            // Đảm bảo có default values cho note fields nếu không có
            // Nếu note null, lấy name từ order_by_ranking
            note_beside: item.note_beside ?? defaultNote,
            font_beside: item.font_beside ?? defaultNoteStyle.font,
            font_size_beside: item.font_size_beside ?? defaultNoteStyle.font_size,
            color_beside: item.color_beside ?? defaultNoteStyle.color,
            stroke_color_beside: item.stroke_color_beside ?? defaultNoteStyle.stroke_color,
            stroke_width_beside: item.stroke_width_beside ?? defaultNoteStyle.stroke_width,
            note_slider: item.note_slider ?? defaultNote,
            font_slider: item.font_slider ?? defaultNoteStyle.font,
            font_size_slider: item.font_size_slider ?? defaultNoteStyle.font_size,
            color_slider: item.color_slider ?? defaultNoteStyle.color,
            stroke_color_slider: item.stroke_color_slider ?? defaultNoteStyle.stroke_color,
            stroke_width_slider: item.stroke_width_slider ?? defaultNoteStyle.stroke_width,
            layout_ranking: item.layout_ranking ?? 0,

            // check that ranking is group ranking
            // if current mode is master, check only ranking_list_shop
            ...(isMaster && item.ranking_list_shop?.length > 0 && { is_group_ranking: true }),
            // if current mode is not master, check ranking_list_shop field in order_by_images_slider_ranking
            ...(!isMaster &&
              item.order_by_image_slider_ranking_id &&
              item.order_by_images_slider_ranking?.ranking_list_shop?.length > 0 && {
                is_group_ranking: true,
              }),
          };
        });

      setImageSliderState(sortedData);
    } else {
      setImageSliderState([]);
    }
  }, [orderByImagesSliderRank]);

  useEffect(() => {
    if (token && selectShop?.id && selectItem?.id) {
      dispatch(
        rankingAction.getOrderByImagesSLiderRanking({
          token,
          params: { shop_id: selectShop.id, program_rank_id: selectItem?.id },
        })
      );
    } else {
      if (selectItem.id) {
        dispatch(
          rankingAction.getOrderByImagesSLiderRanking({
            token,
            params: { permission: 'master', program_rank_id: selectItem?.id },
          })
        );
      } else {
        dispatch(rankingAction.toggleOrderByImagesSliderRankingLoading(false));
      }
    }
  }, [dispatch, selectShop?.id, token, selectItem?.id]);

  useEffect(() => {
    if (token) {
      dispatch(shopListAction.fetchShopList({ token }));
    }
  }, [dispatch, token]);

  // useEffect(() => {
  //   const handleClickOutside = (event: MouseEvent) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
  //       setIsMore([]);
  //     }
  //   };
  //   document.addEventListener('click', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('click', handleClickOutside);
  //   };
  // }, []);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const isClickInsideAnyDropdown = dropdownRefs.current.some(
        (ref) => ref && ref.contains(event.target as Node)
      );
      if (!isClickInsideAnyDropdown) {
        setIsMore([]);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const checkScrollable = () => {
      setHasScroll(el.scrollHeight > el.clientHeight);
    };

    checkScrollable();

    const resizeObserver = new ResizeObserver(checkScrollable);
    resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
    const scrollSection = scrollRef.current;
    if (!scrollSection) return;

    let lastScrollTop = 0;

    const handleScroll = () => {
      const scrollTop = scrollSection.scrollTop;
      const clientHeight = scrollSection.clientHeight;
      const scrollHeight = scrollSection.scrollHeight;

      const nearBottom = scrollTop + clientHeight >= scrollHeight - 200;

      const scrollingDown = scrollTop > lastScrollTop;

      if (nearBottom && scrollingDown) {
        setShowScrollTop(true);
      }

      if (!scrollingDown) {
        setShowScrollTop(false);
      }

      lastScrollTop = scrollTop;
    };

    scrollSection.addEventListener('scroll', handleScroll);

    return () => scrollSection.removeEventListener('scroll', handleScroll);
  }, []);
  // const logNote = (section: any) => {
  //   const result = noteWithOptionRank?.filter((note: any) => {
  //     console.log('section: ', section);
  //     return (
  //       (note?.order_by_ranking_id === section.order_by_ranking_id &&
  //         note?.order_by === section?.order_by &&
  //         note?.name === section?.name &&
  //         moment(note.created_at).isSame(section.created_at))
  //     );
  //   });
  //   console.log('result: ', result);
  // };

  return (
    <Spin
      spinning={orderByImagesSliderRankLoading}
      indicator={<LoadingOutlined style={{ fontSize: 48, color: '#666687' }} spin />}
    >
      <div
        style={{ height: window.innerHeight - 150 }}
        className="flex overflow-y-auto flex-col flex-1 h-full"
      >
        <div className="flex gap-3 justify-between items-center border-b border-border-gray">
          <button
            onClick={() => {
              setSelectItem(arrOption);
              setSelectedProgram(arrOption);
              setIsMore([]);
            }}
            className={`flex justify-center items-center py-2 h-full text-base text-center border-solid lg:py-0 text-primary notosans_bold border-primary border-b-[3px] min-w-[150px]`}
          >
            {arrOption?.name}
          </button>

          {/* PC */}
          <div className="hidden gap-2 items-center py-2 pr-3 lg:flex">
            <button
              onClick={() => customHistory.push('/rank?redirect_from=ranking_setting')}
              className="flex items-center gap-2 w-[150px] h-10 justify-center text-base text-white rounded-lg bg-blue_500 font-notosans-400"
            >
              {cts.previewIcon}
              {t('PREVIEW')}
            </button>
            <button
              onClick={() => {
                setArrOption((prev: any[]) => ({ ...prev, layout_screen: 2 }));
                setSelectItem((prev: any) => ({ ...prev, layout_screen: 2 }));
              }}
              className={`${
                selectItem?.layout_screen === 2
                  ? 'border-primary bg-[#EEEEF8]'
                  : 'border-border-gray'
              } h-10 rounded-lg flex items-center justify-center w-[150px] border-solid border `}
            >
              <span>{selectItem?.layout_screen === 2 ? cts.checkActive : cts.check}</span>
              <span className="text-[#333333] notosans_medium text-base ml-2">1920×1920</span>
            </button>
            <button
              onClick={() => {
                setArrOption((prev: any[]) => ({ ...prev, layout_screen: 1 }));
                setSelectItem((prev: any) => ({ ...prev, layout_screen: 1 }));
              }}
              className={`${
                selectItem?.layout_screen !== 2
                  ? 'border-primary bg-[#EEEEF8]'
                  : 'border-border-gray'
              } h-10 rounded-lg flex items-center justify-center w-[150px] border-solid border `}
            >
              <span>{selectItem?.layout_screen !== 2 ? cts.checkActive : cts.check}</span>
              <span className="text-[#333333] notosans_medium text-base ml-2">{t('DEFAULT')}</span>
            </button>
          </div>
        </div>

        <div className="block px-2 pt-2 space-y-2 lg:hidden">
          <div className="flex gap-2 items-center">
            <button
              onClick={() => customHistory.push('/rank?redirect_from=ranking_setting')}
              className="flex gap-2 justify-center items-center w-full h-10 text-base text-white rounded-lg bg-blue_500 font-notosans-400"
            >
              {cts.previewIcon}
              {t('PREVIEW')}
            </button>
            <button
              onClick={() => {
                setArrOption((prev: any[]) => ({ ...prev, layout_screen: 2 }));
                setSelectItem((prev: any) => ({ ...prev, layout_screen: 2 }));
              }}
              className={`${
                selectItem?.layout_screen === 2
                  ? 'border-primary bg-[#EEEEF8]'
                  : 'border-border-gray'
              } h-10 rounded-lg flex items-center justify-center w-full border-solid border `}
            >
              <span>{selectItem?.layout_screen === 2 ? cts.checkActive : cts.check}</span>
              <span className="text-[#333333] notosans_medium text-base ml-2">1920×1920</span>
            </button>
          </div>
          <button
            onClick={() => {
              setArrOption((prev: any[]) => ({ ...prev, layout_screen: 1 }));
              setSelectItem((prev: any) => ({ ...prev, layout_screen: 1 }));
            }}
            className={`${
              selectItem?.layout_screen !== 2 ? 'border-primary bg-[#EEEEF8]' : 'border-border-gray'
            } h-10 rounded-lg flex items-center justify-center w-full border-solid border `}
          >
            <span>{selectItem?.layout_screen !== 2 ? cts.checkActive : cts.check}</span>
            <span className="text-[#333333] notosans_medium text-base ml-2">{t('DEFAULT')}</span>
          </button>
        </div>
        {/* choose layout program buttons */}
        {arrOption ? (
          <>
            {/* <div className="flex gap-3 justify-center items-center py-2 w-full border-b border-solid border-border-gray">
              <button
                onClick={() => {
                  setArrOption((prev: any[]) => ({ ...prev, layout_screen: 1 }));
                  setSelectItem((prev: any) => ({ ...prev, layout_screen: 1 }));
                }}
                className={`${
                  selectItem?.layout_screen !== 2
                    ? 'border-primary bg-[#EEEEF8]'
                    : 'border-border-gray'
                } h-10 rounded-lg flex items-center justify-center w-[294px] border-solid border `}
              >
                <span>{selectItem?.layout_screen !== 2 ? cts.checkActive : cts.check}</span>
                <span className="text-[#333333] notosans_medium text-base ml-2">
                  {t('DEFAULT')}
                </span>
              </button>
              <button
                onClick={() => {
                  setArrOption((prev: any[]) => ({ ...prev, layout_screen: 2 }));
                  setSelectItem((prev: any) => ({ ...prev, layout_screen: 2 }));
                }}
                className={`${
                  selectItem?.layout_screen === 2
                    ? 'border-primary bg-[#EEEEF8]'
                    : 'border-border-gray'
                } h-10 rounded-lg flex items-center justify-center w-[294px] border-solid border `}
              >
                <span>{selectItem?.layout_screen === 2 ? cts.checkActive : cts.check}</span>
                <span className="text-[#333333] notosans_medium text-base ml-2">1920*1920</span>
              </button>
            </div> */}
            <div className="px-2 py-2 w-full border-b lg:px-0 border-border-gray">
              <button
                onClick={() => setOpenModalSelectItem(true)}
                className="lg:w-[600px] w-full h-10 mx-auto bg-[#FAFAFA] rounded-lg flex items-center justify-center border-border-gray border-dashed border"
              >
                <span>{cts.iconPlus}</span>
                <span className="ml-2 text-sm text-primary notosans_medium">{t('ADDITION')}</span>
              </button>
            </div>
            {/* drag and drop item of program */}
            <div
              ref={scrollRef}
              style={{ height: window.innerHeight - 193 }}
              className={`relative flex flex-col lg:items-center flex-1  mt-2 h-full overflow-auto gap-2 lg:px-0 px-2 w-full ${
                hasScroll ? 'pl-3' : ''
              }`}
            >
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleMainDragEnd}
              >
                <SortableContext items={sortableItems} strategy={verticalListSortingStrategy}>
                  {imageSliderState?.map((section: any, index: number) => (
                    <SortableItem
                      id={`${section.id}-${section.order_by}-${index}`}
                      key={`${section.id}-${section.order_by}-${index}`}
                    >
                      {({ listeners }) => (
                        <button
                          key={`${section.id}-${section.order_by}-${index}`}
                          className={`flex flex-col px-6 py-2 bg-white rounded-lg border border-solid min-w-[600px] border-border-gray lg:w-[600px]`}
                        >
                          <div
                            className="flex justify-between items-center w-full"
                            // ref={(el) => {
                            //   dropdownRefs.current[index] = el;
                            // }}
                          >
                            <div className="flex items-center w-full">
                              <span {...listeners}>{cts.bar}</span>
                              {/* MASTER UPLOADED */}
                              {/* check profit or nomination */}
                              {section.order_by_image_slider_ranking_id &&
                              section.order_by_image_slider_ranking_id !== null ? (
                                <>
                                  {section.order_by_images_slider_ranking?.order_by_ranking_id ? (
                                    <span className="lg:ml-6 ml-2 flex items-center gap-4 text-[#252B37] text-base notosans_normal">
                                      {!section.is_group_ranking
                                        ? __renderShopRankingImage(section)
                                        : __renderGroupShopRankingImage(section)}

                                      <div className="flex overflow-hidden flex-col items-start">
                                        <p>
                                          {t(
                                            section.order_by_images_slider_ranking?.order_by_ranking
                                              ?.name || ''
                                          )}
                                          {section?.order_by_image_slider_ranking_id &&
                                            (section?.order_by_images_slider_ranking
                                              ?.layout_ranking === 1
                                              ? '（一覧）'
                                              : '（個人）')}
                                        </p>

                                        {!section.is_group_ranking ? (
                                          <p>
                                            {shopInfoRanking(section) &&
                                              shopInfoRanking(section)?.name}
                                          </p>
                                        ) : (
                                          __renderGroupShopTooltipName(section)
                                        )}
                                      </div>
                                    </span>
                                  ) : (
                                    // check image or video
                                    <>
                                      {section.order_by_images_slider_ranking?.images_slider?.link?.includes(
                                        '.mp4'
                                      ) ? (
                                        <>
                                          <video
                                            src={`${IMAGE_BASE_URL}/images_slider/${section.order_by_images_slider_ranking?.images_slider?.link}`}
                                            className="ml-6 h-[60px] w-[60px] rounded-md  object-cover"
                                            autoPlay
                                            loop
                                            muted
                                          />

                                          <div className="flex flex-col items-start whitespace-nowrap">
                                            <Tooltip
                                              title={
                                                isMobile
                                                  ? ''
                                                  : section?.order_by_images_slider_ranking
                                                      ?.images_slider?.link
                                              }
                                              placement="topLeft"
                                            >
                                              <p className="ml-4 text-gray-500 truncate cursor-pointer max-w-60 font-notosans-300">
                                                {
                                                  section?.order_by_images_slider_ranking
                                                    ?.images_slider?.link
                                                }
                                              </p>
                                            </Tooltip>

                                            <p className="ml-4 italic text-gray-500 text-start">
                                              ({t('MOVIE')})
                                            </p>
                                            <p className="ml-4 italic text-gray-500 text-start">
                                              ({t('ADMIN')})
                                            </p>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <img
                                            src={`${IMAGE_BASE_URL}/images_slider/${section.order_by_images_slider_ranking?.images_slider?.link}`}
                                            className="ml-6 h-[60px] w-[60px] rounded-md  object-cover"
                                          />
                                          <div className="flex flex-col items-start whitespace-nowrap">
                                            <Tooltip
                                              title={
                                                isMobile
                                                  ? ''
                                                  : section?.order_by_images_slider_ranking
                                                      ?.images_slider?.link
                                              }
                                              placement="topLeft"
                                            >
                                              <p className="ml-4 text-gray-500 truncate cursor-pointer max-w-60 font-notosans-300">
                                                {
                                                  section?.order_by_images_slider_ranking
                                                    ?.images_slider?.link
                                                }
                                              </p>
                                            </Tooltip>
                                            <p className="ml-4 italic text-gray-500 text-start">
                                              ({t('IMAGE')})
                                            </p>
                                            <p className="ml-4 italic text-gray-500 text-start">
                                              ({t('ADMIN')})
                                            </p>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {/* NORMAL MODE, SHOP UPLOADED */}
                                  {section.order_by_ranking_id ? (
                                    <span className="ml-6 flex items-center gap-4 text-[#252B37] text-base notosans_normal ">
                                      {!section.is_group_ranking
                                        ? __renderShopRankingImage(section)
                                        : __renderGroupShopRankingImage(section)}
                                      <div className="flex flex-col items-start whitespace-nowrap">
                                        <p>
                                          {t(section.order_by_ranking?.name || '')}
                                          {/* {section?.order_by_ranking_id &&
                                            (section?.layout_ranking === 1
                                              ? '（一覧）'
                                              : '（個人）')} */}

                                          {__renderRankingLayoutType(section?.layout_ranking)}
                                        </p>
                                        {!section.is_group_ranking ? (
                                          <p>
                                            {shopInfoRanking(section) &&
                                              shopInfoRanking(section)?.name}
                                          </p>
                                        ) : (
                                          __renderGroupShopTooltipName(section)
                                        )}
                                      </div>
                                    </span>
                                  ) : (
                                    // check image or video
                                    <>
                                      {section?.images_slider?.link?.includes('.mp4') ? (
                                        <>
                                          <video
                                            src={`${IMAGE_BASE_URL}/images_slider/${section?.images_slider?.link}`}
                                            className="ml-6 h-[60px] w-[60px] rounded-md  object-cover"
                                            autoPlay
                                            loop
                                            muted
                                          />

                                          <div className="flex flex-col items-start whitespace-nowrap">
                                            <Tooltip
                                              title={isMobile ? '' : section?.images_slider?.link}
                                              placement="topLeft"
                                            >
                                              <p className="ml-4 text-gray-500 truncate cursor-pointer max-w-60 font-notosans-300">
                                                {section?.images_slider?.link}
                                              </p>
                                            </Tooltip>
                                            <p className="ml-4 italic text-gray-500">
                                              ({t('MOVIE')})
                                            </p>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <img
                                            src={`${IMAGE_BASE_URL}/images_slider/${section?.images_slider?.link}`}
                                            className="ml-6 h-[60px] w-[60px] rounded-md  object-cover"
                                          />
                                          <div className="flex flex-col items-start whitespace-nowrap">
                                            <Tooltip
                                              title={isMobile ? '' : section?.images_slider?.link}
                                              placement="topLeft"
                                            >
                                              <p className="ml-4 text-gray-500 truncate cursor-pointer max-w-60 font-notosans-300">
                                                {section?.images_slider?.link}
                                              </p>
                                            </Tooltip>
                                            <p className="ml-4 italic text-gray-500 text-start">
                                              ({t('IMAGE')})
                                            </p>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                            <div className="flex gap-2 justify-between items-center">
                              {/* handle delete item ranking button */}
                              <button
                                disabled={section.order_by_image_slider_ranking_id}
                                onClick={() => {
                                  setSelectSection(section);
                                  setOpenModalDeleteImage(true);
                                  setTypeDelete('program');
                                }}
                                className={`${
                                  section.order_by_image_slider_ranking_id
                                    ? 'bg-gray-100 cursor-not-allowed border-gray-500'
                                    : ''
                                } h-11 w-11 rounded-lg border border-solid border-[#F04438] flex items-center justify-center`}
                              >
                                {section.order_by_image_slider_ranking_id
                                  ? cts.trashDisabledIcon
                                  : cts.trashIcon}
                              </button>

                              {/* handle choose layout for item ranking */}
                              {/* check ranking item is not a standby image or a standby video*/}
                              {section.order_by_ranking_id !== null &&
                              !section.order_by_image_slider_ranking_id &&
                              !section.is_group_ranking ? (
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setOpenSelectLayout(true);
                                    setSelectedItemRanking(section);
                                  }}
                                  className="flex justify-center items-center w-11 h-11 rounded-lg border border-solid border-primary"
                                >
                                  {cts.iconLayout}
                                </button>
                              ) : (
                                <></>
                              )}

                              {/* handle change time for item ranking */}
                              <Input
                                disabled={!section.order_by_image_slider_ranking_id ? false : true}
                                suffix="秒"
                                onFocus={(e) => {
                                  const value = e.target.value;

                                  setImageSliderState((prev) =>
                                    prev.map((item) => {
                                      if (
                                        item.id !== section.id ||
                                        item.order_by !== section.order_by
                                      ) {
                                        return item;
                                      }
                                      if (section.order_by_image_slider_ranking_id) {
                                        return {
                                          ...item,
                                          order_by_images_slider_ranking: {
                                            ...item.order_by_images_slider_ranking,
                                            second_change: Number(value) == 0 ? '' : Number(value),
                                          },
                                        };
                                      }
                                      return {
                                        ...item,
                                        second_change: Number(value) == 0 ? '' : Number(value),
                                      };
                                    })
                                  );
                                }}
                                className="h-11 w-[100px] rounded-lg"
                                style={{ border: '1px solid #D5D7DA' }}
                                value={
                                  section.order_by_image_slider_ranking_id
                                    ? section.order_by_images_slider_ranking?.second_change
                                    : section?.second_change
                                }
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value === '') {
                                    setImageSliderState((prev) =>
                                      prev.map((item) => {
                                        if (
                                          item.id !== section.id ||
                                          item.order_by !== section.order_by
                                        )
                                          return item;

                                        // if (section.order_by_image_slider_ranking_id) {
                                        //   return {
                                        //     ...item,
                                        //     order_by_images_slider_ranking: {
                                        //       ...item.order_by_images_slider_ranking,
                                        //       second_change: '',
                                        //     },
                                        //   };
                                        // }

                                        return {
                                          ...item,
                                          second_change: '',
                                        };
                                      })
                                    );
                                    return;
                                  }
                                  if (/^\d*$/.test(value)) {
                                    setImageSliderState((prev) =>
                                      prev.map((item) => {
                                        if (
                                          item.id !== section.id ||
                                          item.order_by !== section.order_by
                                        )
                                          return item;
                                        if (section.order_by_image_slider_ranking_id) {
                                          return {
                                            ...item,
                                            order_by_images_slider_ranking: {
                                              ...item.order_by_images_slider_ranking,
                                              second_change: Number(value),
                                            },
                                          };
                                        }

                                        return {
                                          ...item,
                                          second_change: Number(value),
                                        };
                                      })
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                          {/* program item expanded by clicking show detail*/}
                          {isMore.some(
                            (item: { order_by_ranking_id: number; order_by: number }) =>
                              item.order_by_ranking_id === section.order_by_ranking_id &&
                              item.order_by === section.order_by
                          ) && (
                            <>
                              {/* {logNote(section)} */}
                              {noteWithOptionRank
                                ?.filter((note: any) => {
                                  return (
                                    note?.order_by_image_slider_ranking_id === section.id ||
                                    (note?.order_by_ranking_id === section.order_by_ranking_id &&
                                      note?.order_by === section?.order_by &&
                                      note?.name === section?.name &&
                                      moment(note.created_at).isSame(section.created_at))
                                  );
                                  // filter at master mode (master can have item with same id, so we compare with order_by and created_at to get exact item)
                                })
                                ?.map((x: any, y: any) => {
                                  return (
                                    <button
                                      key={y}
                                      className={`${
                                        y === 0 ? 'border-t mt-2' : ''
                                      } border-b border-solid bg-white border-border-gray py-4 flex items-center justify-between pl-12 w-full`}
                                    >
                                      <span className=" text-[#252B37] text-base notosans_normal">
                                        No.{x?.rank}
                                      </span>
                                      <div
                                        className="flex items-center"
                                        onClick={(e) => e.stopPropagation()}
                                        onMouseDown={(e) => e.stopPropagation()}
                                      >
                                        {__renderDisplayPositionRanking(section, x)}
                                        <Input
                                          suffix="秒"
                                          className={`${
                                            section?.layout_ranking === 1 && 'hidden'
                                          } h-11 w-[100px] rounded-lg ml-4`}
                                          style={{ border: '1px solid #D5D7DA' }}
                                          value={
                                            orderByRankingInPosRanking?.find(
                                              (item: any) => item.id === x?.order_by_ranking_id
                                            )?.name === 'PROFIT_DAY'
                                              ? x?.time_profit_day
                                              : orderByRankingInPosRanking?.find(
                                                    (item: any) =>
                                                      item.id === x?.order_by_ranking_id
                                                  )?.name === 'PROFIT_MONTH'
                                                ? x?.time_profit_month
                                                : orderByRankingInPosRanking?.find(
                                                      (item: any) =>
                                                        item.id === x?.order_by_ranking_id
                                                    )?.name === 'NOMINATION_DAY'
                                                  ? x?.time_nomination_day
                                                  : x?.time_nomination_month
                                          }
                                          onChange={(e) => onEditNote(e, x, section)}
                                        />
                                      </div>
                                    </button>
                                  );
                                })}
                            </>
                          )}
                          {/* program item expand button */}
                          {/* {section.order_by_ranking_id && (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsMore((prev: any) => {
                                  if (
                                    prev.some(
                                      (item: { order_by_ranking_id: number; order_by: number }) =>
                                        item.order_by_ranking_id === section.order_by_ranking_id &&
                                        item.order_by === section.order_by
                                    )
                                  ) {
                                    return prev.filter(
                                      (item: any) =>
                                        item.id !== section.id &&
                                        item.order_by_ranking_id !== section.order_by_ranking_id
                                    );
                                  } else {
                                    return [
                                      ...prev,
                                      {
                                        order_by: section.order_by,
                                        order_by_ranking_id: section.order_by_ranking_id,
                                      },
                                    ];
                                  }
                                });
                              }}
                              className={`flex justify-center items-center mt-2 text-primary notosans_medium`}
                            >
                              {isMore.some(
                                (item: { order_by_ranking_id: number; order_by: number }) =>
                                  item.order_by_ranking_id === section.order_by_ranking_id &&
                                  item.order_by === section.order_by
                              )
                                ? t('CLOSE')
                                : t('MORE')}
                              <span
                                className={`ml-2 transition-all ${
                                  isMore.some(
                                    (item: { order_by_ranking_id: number; order_by: number }) =>
                                      item.order_by_ranking_id === section.order_by_ranking_id &&
                                      item.order_by === section.order_by
                                  ) && 'rotate-180'
                                }`}
                              >
                                {cts.down}
                              </span>
                            </button>
                          )} */}
                        </button>
                      )}
                    </SortableItem>
                  ))}
                </SortableContext>
              </DndContext>
              {showScrollTop && (
                <button
                  onClick={handleMoveToTop}
                  className={`fixed flex bottom-[115px] items-center justify-center bg-white border-2 border-solid rounded-full right-[10%] border-primary size-11 ${
                    showScrollTop ? 'move-to-top-show' : 'move-to-top-hide'
                  }`}
                >
                  {cts.arrowUpIcon}
                </button>
              )}
            </div>
          </>
        ) : (
          <div className="flex justify-center items-center py-10">
            <Empty description={t('NO_DATA')} />
          </div>
        )}
        <ModalDeleteImage
          openConfirm={openModalDeleteImage}
          setOpenConfirm={setOpenModalDeleteImage}
          handleDeleteImage={handleDeleteImage}
          title={typeDelete === 'program' ? t('CONFIRM_DEL_POSITION') : t('CONFIRM_DEL_PROGRAM')}
        />
        <ModalSelectItemProgram
          open={openModalSelectItem}
          setOpen={setOpenModalSelectItem}
          data={imageSlider}
          dataTab1={orderByRankingInPosRanking}
          setImageSliderState={setImageSliderState}
          imageSliderState={imageSliderState}
          selectItem={selectItem}
        />
        <ModalChangeLayoutRankingItem
          setImageSliderState={setImageSliderState}
          imageSliderState={imageSliderState}
          open={openSelectLayout}
          selectItem={selectItem}
          selectedItemRanking={selectedItemRanking}
          setOpen={setOpenSelectLayout}
        />
      </div>
    </Spin>
  );
});

export default ProgramingV2;
